export default __webpack_public_path__ + "static/media/USAA dark.bbbd1d1a.svg";